export default __webpack_public_path__ + "static/media/uaepass-round.106ab7fe.svg";